import { ReconstructPath } from "./types";

/**
 * Reconstructs a path from start to end using Dijkstra previous-pointers.
 */
export const reconstructPath: ReconstructPath = ({
  previous,
  startNodeId,
  endNodeId,
}) => {
  // If the end node isn't in the history (unreachable) and isn't the start, no path exists.
  if (!(endNodeId in previous) && endNodeId !== startNodeId) {
    return [];
  }

  const path: string[] = [];
  let current = endNodeId;

  // Trace back from End -> Start
  while (current !== startNodeId) {
    path.push(current);

    const prev = previous[current];

    // Safety check: if history is broken, stop
    if (!prev) {
      return [];
    }

    current = prev;
  }

  path.push(startNodeId);

  // Reverse to get Start -> End order
  path.reverse();

  return path;
};
